module.exports = __webpack_public_path__ + "img/tiktok.dd51865a.svg";